import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=3dcf2afd&scoped=true&"
import script from "./infomation.vue?vue&type=script&lang=js&"
export * from "./infomation.vue?vue&type=script&lang=js&"
import style0 from "./infomation.vue?vue&type=style&index=0&id=3dcf2afd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf2afd",
  null
  
)

export default component.exports